import { render, staticRenderFns } from "./PosInvoiceReceiptFull.vue?vue&type=template&id=958aeef6&scoped=true&"
import script from "./PosInvoiceReceiptFull.vue?vue&type=script&lang=js&"
export * from "./PosInvoiceReceiptFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958aeef6",
  null
  
)

export default component.exports